import ComingSoon from "../../../components/ComingSoon/ComingSoon";

const ContractTimeSheet = () => {
  return <ComingSoon isFooterVisible={false} isHeaderVisible={false} />;
};

export default ContractTimeSheet;
